var exports = {
  "kL": "x93eb46d8--54cb38--container",
  "Xj": "x93eb46d8--54cb38--container_under-construction",
  "Kk": "x93eb46d8--54cb38--icon",
  "UU": "x93eb46d8--54cb38--name",
};

module.exports = exports;
